import React, { useEffect, useState, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import ZouraIframe from '../ZouraBillingForm/ZouraIframe'

import './ZouraPaymentPage.css'

const ZuoraPaymentPage = forwardRef(
  ({ pageDetails, onSuccessHandler, isHidden }, ref) => {
    const dispatch = useDispatch()
    const [iframeHeight, setIframeHeight] = useState(450)

    useEffect(() => {
      const handleResize = event => {
        if (
          event.data?.type === 'zuora-resize' &&
          event.data?.pageId === pageDetails?.pageId
        ) {
          setIframeHeight(event.data.height)
        }
      }
      window.addEventListener('message', handleResize)
      return () => window.removeEventListener('message', handleResize)
    }, [pageDetails?.pageId])

    useEffect(() => {
      if (isHidden) return
      window.addEventListener('message', receive, false)
      window.addEventListener('message', zouraFail, false)
      return () => window?.removeEventListener('message', receive)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isHidden, onSuccessHandler])

    function zouraFail(event) {
      if (event.data === 'error') {
        console.log('Zoura failed to load: ', event)
        dispatch(Actions.createAction(Actions.DISABLE_ZOURA_PAGE_LOADER))
      }
    }

    function receive(evt) {
      let data = evt.data
      if (data?.success === 'true') {
        dispatch(Actions.createAction(Actions.DISABLE_ZOURA_PAGE_LOADER))
        onSuccessHandler(data)
      }
      if (data?.success === 'false') {
        dispatch(Actions.createAction(Actions.DISABLE_ZOURA_PAGE_LOADER))
        // Requesting Payment Page failed. Error handling code should be added here. Simply forward to the callback url in sample code.
        //   onCanceledHandler()
        dispatch(Actions.createAction(Actions.REDIRECT_TO_PAYMENT_CANCEL))
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'payment_cancel_web'
            // data: { selectedPlan },
          })
        )
      }
    }

    useEffect(() => {
      //This is to clean zoura data on reload and back of page to prevent redirections to billing url
      return () => {
        dispatch(Actions.createAction(Actions.CLEAR_ZOURA_SIGNATURES))
      }
    }, [])

    return (
      <div
        className={`zoura-payment-iframe  ${
          isHidden ? 'hidden' : 'zoura-payment-iframe-display'
        }`}
        style={!isHidden ? { height: iframeHeight } : undefined}
      >
        <ZouraIframe ref={ref} pageDetails={pageDetails} />
      </div>
    )
  }
)

ZuoraPaymentPage.displayName = 'ZuoraPaymentPage'

export default ZuoraPaymentPage
